import React, { useState, useEffect } from 'react';
import CitizenImpactCards from './CitizenImpactCards';
import './CitizenImpactDashboard.css';
import CitizenImpactSidebar from './CitizenImpactSidebar';
import CitizenImpactMap from './CitizenImpactMap';
import CitizenImpactRightSidebar from './CitizenImpactRightSidebar';
import { CitizenImpactButtonContainer } from './CitizenImpactButton';
import CitizenImpactTable from './CitizenImpactTable';

const CitizenImpactDashboard = () => {
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedAgeRange, setSelectedAgeRange] = useState(null);
  const [selectedProjectName, setSelectedProjectName] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState({ start: '', end: '' }); // NEW
  const [lastUpdated, setLastUpdated] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const handleCategoryChange = (selectedCategory) => {
    console.log('Selected Category:', selectedCategory);
    // Add any additional logic needed for category changes
  };

  useEffect(() => {
    // Fetch the date and time from the date&time.json file in the public folder
    const fetchLastUpdated = async () => {
      try {
        const response = await fetch('/db2_date&time.json');
        const data = await response.json();
        setLastUpdated(new Date(data.updatedAt).toLocaleString());
      } catch (error) {
        console.error('Error fetching last updated time:', error);
      }
    };

    fetchLastUpdated();
  }, []);

  return (
    <div className="citizenimpact-main-content">
      <CitizenImpactCards />
      <div className="citizenimpact-dashboard">
      <CitizenImpactSidebar 
  onGenderChange={setSelectedGender}
  onAgeRangeChange={setSelectedAgeRange}
  onStateChange={setSelectedState}
  onDistrictChange={setSelectedDistrict} 
  onProjectNameChange={setSelectedProjectName}
  onDateRangeChange={setSelectedDateRange}
/>
        <div className="citizenimpact-map-container">
          <CitizenImpactButtonContainer />
          <CitizenImpactMap 
  selectedGender={selectedGender}
  selectedAgeRange={selectedAgeRange}
  selectedState={selectedState}
  selectedDistrict={selectedDistrict}
  selectedProjectName={selectedProjectName}
  selectedDateRange={selectedDateRange}
/>
        </div>
        <div className="citizenimpact-rightsidebar-container">
          {/* {lastUpdated && (
            <div className="last-updated">
              <p>Last updated: {lastUpdated}</p>
            </div>
          )} */}
          <CitizenImpactRightSidebar
  selectedGender={selectedGender}
  selectedAgeRange={selectedAgeRange}
  selectedState={selectedState}
  selectedDistrict={selectedDistrict} 
  selectedProjectName={selectedProjectName}
/>
        </div>
      </div>
      <CitizenImpactTable
  selectedGender={selectedGender}
  selectedAgeRange={selectedAgeRange}
  selectedProjectName={selectedProjectName}
  selectedDateRange={selectedDateRange}
/>
    </div>
  );
};

export default CitizenImpactDashboard;
